




import { defineComponent } from "@nuxtjs/composition-api";
export default defineComponent({
  name: "MvStyle",
  props: {
    tag: {
      type: String,
      default: "style",
    },
    content: {
      type: String,
      default: "",
    },
  },
});
